import { createRoutine } from 'redux-saga-routines';

export const createSuccessPlanTemplate = createRoutine(
  'CREATE_SUCCESS_PLAN_TEMPLATE'
);
export const fetchAllSuccessPlanTemplates = createRoutine(
  'FETCH_ALL_SUCCESS_PLAN_TEMPLATES'
);
export const fetchSuccessPlanTemplateById = createRoutine(
  'FETCH_SUCCESS_PLAN_TEMPLATE_BY_ID'
);
export const updateSuccessPlanTemplate = createRoutine(
  'UPDATE_SUCCESS_PLAN_TEMPLATE'
);
export const archiveSuccessPlanTemplate = createRoutine(
  'ARCHIVE_SUCCESS_PLAN_TEMPLATE'
);
export const duplicateSuccessPlanTemplate = createRoutine(
  'DUPLICATE_SUCCESS_PLAN_TEMPLATE'
);
